module.exports = __webpack_public_path__ + "img/Footer.0f7660a5.png";